import React from "react";
import { X } from "lucide-react";

/**
 * Reusable side drawer used by RoomsPanel, CrewPanel, EquipmentPanel, ProjectPanel.
 * Visual matches the rest of the GrandMA3 console.
 */
export default function Drawer({ open, onClose, title, subtitle, count, children, footer, width = 420, dataTestid }) {
  if (!open) return null;
  return (
    <div className="drawer animate-slide-in-right" style={{ width }} data-testid={dataTestid || "drawer"}>
      <div className="flex items-center justify-between p-3 border-b border-line-strong bg-bg-surface">
        <div className="min-w-0">
          <div className="mono text-2xs uppercase tracking-[0.2em] text-ink-mute">
            {title}
            {count != null && (
              <span className="text-amber ml-2">· {count}</span>
            )}
          </div>
          {subtitle && (
            <div className="text-sm text-ink mt-0.5 truncate">{subtitle}</div>
          )}
        </div>
        <button onClick={onClose} className="btn-ghost" data-testid="drawer-close">
          <X className="w-3 h-3" />
        </button>
      </div>
      <div className="flex-1 overflow-auto">{children}</div>
      {footer && (
        <div className="p-3 border-t border-line bg-bg-surface">{footer}</div>
      )}
    </div>
  );
}

export function PanelSection({ title, children }) {
  return (
    <div className="border-b border-line">
      {title && <div className="mono text-2xs uppercase tracking-[0.2em] text-ink-mute px-3 pt-3 pb-1">{title}</div>}
      <div className="px-3 pb-3">{children}</div>
    </div>
  );
}

export function PanelInput({ label, value, onChange, type = "text", placeholder, dataTestid, options }) {
  return (
    <label className="block mb-2">
      <span className="mono text-2xs uppercase tracking-widest text-ink-mute block mb-1">{label}</span>
      {options ? (
        <select
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          className="w-full bg-bg-elevated text-xs p-1.5 outline-none border border-line focus:border-amber"
          data-testid={dataTestid}
        >
          {options.map((o) => (
            <option key={o.value} value={o.value}>{o.label}</option>
          ))}
        </select>
      ) : (
        <input
          type={type}
          value={value || ""}
          onChange={(e) => onChange(type === "number" ? (e.target.value === "" ? "" : +e.target.value) : e.target.value)}
          placeholder={placeholder}
          className="w-full bg-bg-elevated text-xs p-1.5 outline-none border border-line focus:border-amber"
          data-testid={dataTestid}
        />
      )}
    </label>
  );
}
